import React from 'react'
import { Menu, Layout, Icon, Badge, Button } from 'antd'
import { withRouter, Link } from 'react-router-dom'
let logo = '/images/icon/logo-tagline-colour.png';
let logoWhite = '/images/icon/logo-tagline-white.png';

const { Header: AntHeader } = Layout
const { SubMenu, Item } = Menu

const DesktopMenu = ({
  t,
  contact,
  authenticated,
  logout,
  active
}) => {


  let Menus = (
    <Menu
      style={{ border: 'none', background: 'transparent'}}
      mode="horizontal"
    >
      <Item style={{ padding: '10px 20px'}}>
        <Link to="/ben-jij-óók-op-zoek-naar-die-leukere-baan" style={{color: active == 1 ? '#4B4B4B' : '#fff'}}>
          {t("News")}
        </Link>
      </Item>
      <Item style={{ padding: '10px 20px'}}>
        <Link to="/team-members" style={{color: active == 1 ? '#4B4B4B' : '#fff'}}>
          {t("Team")}
        </Link>
      </Item>
      <Item style={{ padding: '10px 20px'}}>
        <Link to="/privacy-by-design" style={{color: active == 1 ? '#4B4B4B' : '#fff'}}>
          {t("Privacy")}
        </Link>
      </Item>
      <Item onClick={() => contact()} style={{color: active == 1 ? '#4B4B4B' : '#fff', padding: '10px 20px'}}>
        {t("Contact")}
      </Item>
      {authenticated &&
        <Item onClick={() => logout()} style={{color: active == 1 ? '#4B4B4B' : '#fff', float: 'right', padding: '10px 20px'}}>
          {t("Logout")}
        </Item>
      }
      {!authenticated &&
        <Item style={{float: 'right', paddingRight: 0, padding: '10px 20px'}} >
          <Link to="/signup">
            <Button style={{borderRadius: 6, fontSize:16 }} type="primary-global medium">{t("Create Account")}</Button>
          </Link>
        </Item>
      }
      {!authenticated &&
        <Item style={{float: 'right', padding: '10px 20px'}}>
          <Link to="/login" style={{marginRight: 10, color: active == 1 ? '#4B4B4B' : '#fff'}}>
            {t("sign_in")}
          </Link>
        </Item>
      }
    </Menu>
  )

  return (
    <AntHeader
      className="header"
      style={{
        background: active == 1 ? 'white' : 'linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%)',
        boxShadow: active == 1 ? '0 2px 10px 0 rgba(0,0,0,0.2)' : 'unset',
        color: 'blue',
        position: 'fixed',
        width: '100%',
        height: 'unset',
        transition: 'all0.3s'
      }}
    >
      <hr
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.4)',
          position: 'absolute',
          bottom: 0,
          width: '97.5%',
          left: 0,
          right: 0,
          margin: '0 auto',
          display: active == 1 ? 'none' : 'unset',
        }}
      />
      <div
        style={{
          alignItems: 'center',
          width: '100%',
          flexDirection: "row"
        }}
      >
        <Link
          to="/"
          style={{ float: 'left', padding:'10px 20px' }}
        >

        <img src={logo} style={{height: '36px', width: 'auto', display: active == 0 ? 'none': 'unset', transition: 'all0.3s'}}/>
        <img src={logoWhite} style={{height: '36px', width: 'auto', display: active == 1 ? 'none': 'unset', transition: 'all0.3s'}}/>
        </Link>
      </div>
      {Menus}
    </AntHeader>
  )
}

export default (DesktopMenu)
